import React from 'react'

import { SimpleTable } from 'components/table'

type CampaignHealthTableProps = {
  currency: string
  stats: any
}

const renderNumber = (field: string) => (data: any) => data[field]

const CampaignHealthTable = ({ currency, stats }: CampaignHealthTableProps) => {
  const config = [
    { title: 'Date', field: 'date' },
    { title: 'Views', render: renderNumber('views') },
    { title: 'Clicks', render: renderNumber('clicks') },
    { title: 'Exchange Views', render: renderNumber('exchangeViews') },
    { title: 'Exchange Clicks', render: renderNumber('exchangeClicks') },
    { title: 'Exchange Cost', render: (data: any) => `${data.exchangeCost} ${currency}` },
  ]

  return (
    <div className="campaign-health-table">
      <SimpleTable config={config} data={stats.slice(-7)} striped />
    </div>
  )
}

export default CampaignHealthTable
